import React, { createContext, useContext, useRef, useEffect, useState } from 'react';
import EventEmitter from 'events'; // Node's built-in EventEmitter or use a library like 'eventemitter3'

const AudioPlayerContext = createContext();
const eventEmitter = new EventEmitter();

export const useAudioPlayerContext = () => useContext(AudioPlayerContext);

export const PLAYING = "playing";
export const STOPPED = "stopped";
export const LOADING = "loading";

export const AudioPlayerProvider = ({ children }) => {
  const playingAudioRef = useRef(null);

  const playAudio = (newAudioRef, componentId) => {
    if (playingAudioRef.current && playingAudioRef.current !== newAudioRef) {
      playingAudioRef.current.pause();
      playingAudioRef.current.currentTime = 0;
      eventEmitter.emit('stop', componentId); // Emit a stop event except for the component that triggered play
    }
    playingAudioRef.current = newAudioRef;
  };

  const stopAudio = () => {
    if (playingAudioRef.current) {
      playingAudioRef.current.pause();
      playingAudioRef.current.currentTime = 0;
      eventEmitter.emit('stop', null);
    }
  }

  return (
    <AudioPlayerContext.Provider value={{ playAudio, eventEmitter, stopAudio }}>
      {children}
    </AudioPlayerContext.Provider>
  );
};
